import { render, staticRenderFns } from "./CrewStatusList.vue?vue&type=template&id=24a5f03a"
import script from "./CrewStatusList.vue?vue&type=script&lang=js"
export * from "./CrewStatusList.vue?vue&type=script&lang=js"
import style0 from "./CrewStatusList.vue?vue&type=style&index=0&id=24a5f03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports